import React from 'react';
import Navbar from '../../components/Items/Navbar';
import '../../components/home/HomeDashboard.css';
import './learn.css';

export default function LearnPageShell({ userProfile, loading = false, children, className = '' }) {
  return (
    <div className="learn-app-shell">
      <Navbar userProfile={userProfile} loading={loading} />
      <div
        className={`app-page-shell home-page-shell home-page-shell--minimal learn-page-shell ${className}`.trim()}
      >
        <div className="learn-stack">{children}</div>
      </div>
    </div>
  );
}
